export const RESERVATION_TYPE_IDS_ALLOWING_COUPONS = [
  'af95e0a2-3abd-11ed-8692-0242ac120005', // Partnership Corporate Offsite
  'af95e0ca-3abd-11ed-8692-0242ac120005', // Partnership Group Booking
  'af95e11a-3abd-11ed-8692-0242ac120005', // Standard,
]

export const MEMBERSHIP_COUPON_CODE = 'AVANTSTAY_MEMBER'
export const COUPON_DISCOUNT_TAX_FEE_ID = '572a9a9a-aa27-42ee-97e0-adb900f5de5e'
